import { MaterialIcon } from '@gravitate-js/excalibrr'
import { Tabs } from 'antd'
import React from 'react'

import type { Invoice } from '../../../../../api/useFreight/types'

interface MultipleInvoiceTabProps {
  selectedInvoice: Invoice
  setSelectedInvoice: (invoice: Invoice) => void
  invoiceTabs: Invoice[]
}

/**
 * Displays tabs for navigating between multiple invoices in a group
 * (original, rebill, and credit invoices)
 */
export function MultipleInvoiceTab({ selectedInvoice, setSelectedInvoice, invoiceTabs }: MultipleInvoiceTabProps) {
  // Don't render tabs if there's only one invoice
  if (invoiceTabs.length <= 1) return null

  // Get the appropriate icon for each invoice type
  const getIcon = (invoice: Invoice) => {
    if (invoice.type === 'credit') {
      return <MaterialIcon icon='source_notes' />
    }
    if (invoice.type === 'rebill') {
      return <MaterialIcon icon='list_alt_add' />
    }
    return <MaterialIcon icon='file_copy_off' />
  }

  // Generate tab configuration
  const tabItems = invoiceTabs.map((invoice) => ({
    key: invoice.invoice_number,
    label: invoice.invoice_number,
    icon: getIcon(invoice),
  }))

  return (
    <Tabs
      style={{ textTransform: 'uppercase', marginTop: '-8px', width: '100%' }}
      activeKey={selectedInvoice.invoice_number}
      onChange={(key) =>
        setSelectedInvoice(invoiceTabs.find((invoice) => invoice.invoice_number === key) || invoiceTabs[0])
      }
      items={tabItems}
    />
  )
}
